import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Activities from "components/Activities";
import Tasks from "components/Tasks/Tasks";
import NewActivityRoute from "Routes/NewActivityRoute";
import ClaimTask from "components/Tasks/ClaimTask";
import PrivateRoute from "Routes/PrivateRoute";
import Global404 from "components/Errors/Global404";
import TaskPage from "pages/TaskPage";
import Playground from "pages/Playground";
import Admin from "components/Admin";
import PermissionError from "components/Errors/PermissionError";
import Profile from "components/Profile";
import FormDesignerLayout from "components/FormDesigner/Layouts/FormDesignerLayout";
import Workflows from "components/Workflows";
import TasksAdminView from "components/TasksViews/TasksAdminView";
import TaskDetailedView from "components/TasksViews/DetailedView/TaskDetailedView";
import ActivityInstances from "components/ActivityInstances";
import ActivityInstanceDetailedView from "components/ActivityInstances/DetailedView/ActivityInstanceDetailedView";
import TasksManagerViewContainer from "components/TasksViews/TasksManagerView/TasksList/TasksManagerViewContainer";
import Views from "components/Views";
import CustomViews from "components/CustomViews";

function DashboardRoutes() {
	return (
		<Switch>
			<PrivateRoute
				path="/"
				exact={true}
				render={() => <Redirect to="/tasks/my-tasks/" />}
			/>

			<PrivateRoute
				exact={true}
				path="/activities/start"
				component={Activities}
			/>

			<PrivateRoute
				exact={true}
				path="/activities/start/:id"
				component={NewActivityRoute}
			/>

			<PrivateRoute path="/task/:tid" exact component={TaskPage} />

			<PrivateRoute path="/playground" component={Playground} />

			<PrivateRoute path="/tasks" component={Tasks} />

			<PrivateRoute path="/claimtask/:id" exact component={ClaimTask} />

			<PrivateRoute path="/admin/tasks" component={TasksAdminView} />

			<PrivateRoute path="/:type/task/:id" component={TaskDetailedView} />

			<PrivateRoute path="/admin" component={Admin} />

			<PrivateRoute path="/profile" component={Profile} />

			<PrivateRoute path="/formdesigner" component={FormDesignerLayout} />

			<PrivateRoute path="/workflows" component={Workflows} />

			<PrivateRoute path="/views" component={CustomViews} />

			<PrivateRoute path="/viewdefinitions" component={Views} />

			<PrivateRoute
				path="/activity-instances"
				component={ActivityInstances}
			/>

			<PrivateRoute
				path="/activity-instance/:id"
				component={ActivityInstanceDetailedView}
			/>

			<PrivateRoute
				path="/manager/tasks"
				component={TasksManagerViewContainer}
			/>

			<PrivateRoute path="/views" component={Views} />

			<PrivateRoute path="/403" exact component={PermissionError} />

			<Route component={Global404} />
		</Switch>
	);
}

export default DashboardRoutes;
